import { escape } from "./escape.js";
import { escapeRegExp } from "./escapeRegExp.js";
import { nbsp } from "./unicodes/nbsp.js";
import { wordjoiner } from "./unicodes/wordjoiner.js";

const formatStartSymbol = "[[";
const formatEndSymbol = "]]";

const formatTextReplacements = {
	nl: "<br />",
	semibold: '<span class="font-semibold">$1</span>',
	bold: '<span class="font-bold">$1</span>',
	extrabold: '<span class="font-extrabold">$1</span>',
	"l\\[(.*?)\\]":
		'<a href="$1" class="group/underline"><span class="underline-hover [@media(hover:none)]:underline">$2</span></a>',
	uppercase: '<span class="uppercase">$1</span>',
	stroke: '<span class="stroke-text-cmcsecondary text-cmcbg">$1</span>',
	hover: '<span class="underline-hover">$1</span>',
	underlinegroup: '<span class="group/underline">$1</span>',
	underline: "<u>$1</u>",
	q: "<q>$1</q>",
};

const escapedFormatStartSymbol = escapeRegExp(formatStartSymbol);
const escapedFormatEndSymbol = escapeRegExp(formatEndSymbol);

export function formatify(input: string | undefined): string {
	let result = input ?? "";
	result = result.normalize("NFC");
	result = result.replace(
		new RegExp(
			`(?<=(?:^|[^\\p{General_Category=Letter}])[\\p{General_Category=Letter}|&](?:${escapeRegExp(formatEndSymbol)})?) +|\\s(?=\\d|%)|(?<=\\d)\\s`,
			"gu",
		),
		nbsp,
	);
	result = result.replace(
		/(?<=\p{General_Category=Letter})-(?=\p{General_Category=Letter})(?![^[]*\]\[\[)/gu,
		`${wordjoiner}-${wordjoiner}`,
	);
	result = escape(result);

	for (const [start, replacement] of Object.entries(formatTextReplacements)) {
		result = result.replace(
			new RegExp(`${start}${escapedFormatStartSymbol}(.*?)${escapedFormatEndSymbol}`, "gu"),
			replacement,
		);
	}

	return result;
}
